function getHostJSafra() {
  const currentUrl = window.location.href;

  if (currentUrl.indexOf("-homol.") !== -1 || currentUrl.indexOf("localhost") !== -1) {
    return "https://scdcap-h.safra.com.br/asp/CDCVerBoletos.asp";
  }
  return "https://wwws.jsafra.com.br/asp/CDCVerBoletos.asp";
}

const formExtratoTarifas = {
  form: document.querySelector(".js-form-extrato-tarifas"),
  formHidden: document.querySelector("form.formHidden"),
  radioTipoSacado: document.querySelectorAll('input[name="tipo_sacado"]'),
  hostSafra: getHostJSafra(),
  pristine: {},
  init() {
    this.formInitialize();
  },
  formInitialize() {
    this.form.querySelector("#cnpj-block").style.display = 'none';

    for (let i = 0; i < this.radioTipoSacado.length; i++) {
      this.radioTipoSacado[i].addEventListener("change", function () {

        const tipoSacado = this.form.querySelector('input[name="tipo_sacado"]:checked').value;

        if(tipoSacado == 'F'){
            this.form.querySelector("#cpf-block").style.display = 'block';
            this.form.querySelector("#cpf").checked = true;
            this.form.querySelector("#cnpj-block").style.display = 'none';
        }else{
            this.form.querySelector("#cpf-block").style.display = 'none';
            this.form.querySelector("#cnpj-block").style.display = 'block';
            this.form.querySelector("#cnpj").checked = true;
        }

      });
    }

    this.formHidden.action = this.hostSafra;
    this.pristine = new Pristine(this.form);

    IMask(this.form.querySelector("#cnpj"), {
        mask: "00.000.000/0000-00",
      });

    IMask(this.form.querySelector("#cpf"), {
      mask: "000.000.000-00",
    });

    this.form.addEventListener("submit", (event) => {
       event.preventDefault();

        const tipoSacado = this.form.querySelector('input[name="tipo_sacado"]:checked').value;
        const doc = tipoSacado == "F" ? document.querySelector("input#cpf").value : document.querySelector("input#cnpj").value;
        this.formHidden.querySelector('[name="sacado"]').value = doc.replace(/[^0-9]/g, "");
        this.formHidden.querySelector('[name="tipo_sacado"]').value = tipoSacado;
        this.formHidden.submit();
        
    });
  },
};

formExtratoTarifas.init();
